var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarbel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 196.41 82.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 18.68,
    cy: 39.3,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.98,18.8c3.3-4.4,11.1-9.2,14.8-11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M96.28,18.8c2.3-2,4.7-3.8,7.3-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M130.38,58.1c2.2,1.8,3.9,2.9,6.4,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M125.38,61.1c3.3,2.5,5.3,3.9,8.8,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M29.88,43.8c.7,4.7-1.3,8.5-5.7,11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160.98,35.6c4-.3,7.1-1.9,10.5-4,4.7-2.9,10.7-5.4,16.4-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160.98,41.4c4,.3,7.1,1.9,10.5,4,5.4,3.3,12.5,6.1,18.9,5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M159.48,38.5c4,.1,8,.3,12,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M33.88,25.7c11.1,8,12.6,19,3.7,26.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.48,46.8c.9-4.9,1.1-11.6,.2-15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.58,54.8c16.2,6.1,33.9,8,50.8,8.4,6.9,.2,12.7-.5,19.6-1,8.6-.6,15.6-2.2,24.8-5.3,7.1-2.4,15.3-6.5,22.5-8.8,1.9-.6,3.8-1.1,5.8-1.3,1.7-.2,3.5-.2,5.2-.2,10.8,.2,19.8,5.6,29.8,8.7,2.4,.8,7.6,2.5,10.5,2.7,1.6,.1,2.3-1.8,1.5-3.2-1.9-3.2-13.8-13.4-14.8-16.3-1.1-3.2,14.1-18.2,14.4-18.8,.9-1.5-.4-1.9-2-1.8-2.6,.2-7.5,1.4-9.6,2.3-7.7,3.1-12.5,5.6-18.7,8.9-6,3.2-13.1,3.7-19.5,1.5-19-6.5-37.4-11.5-54.4-11.8-14.9-.3-16.2-.2-32.1,1.8-9.6,1.2-19.8,3.5-29,6.5-2.5,.8-5.5,2-7.9,2.9-3.4,1.3-7,2.6-10.3,4.2-4,2-8.5,5-6.5,8.3,2.2,3.8,7,6.1,10.8,8.1,2.9,1.7,6,3,9.1,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M79.88,18.7c3.3-3.9,5.2-6,8.5-9.1,2.9-2.6,6.5-4.7,10.4-6.5,.7-.3,1.8-1,2.5-1.1-.1,.8,.1,2.4,.1,2.6,.5,3.6,1.1,4.8,2.6,7.2,1.3,2.2,3.4,4,5.6,5.4l-4.2,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M115.58,58.2c3.4,3.7,5.1,5,9.2,8.3,3.5,2.8,4.9,3.2,6,3.5,0,0,8.8-1.4,6.8-12.5l-6.7-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M85.08,69.5c2,3.2,2.7,4.8,5.5,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M76.68,63.2c2.5,7.9,0,0,2.7,8.5,1.2,3.9,4.2,8,5,8.9,0,0,9.1-.1,10.8-10.1l-8.8-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M43.38,66.4c.8,2.5,1.4,4,2.6,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34.98,58.8c.4,3.9,.9,5,2,9.1,.9,3.5,1.7,4.4,2.4,5.1,0,0,7,3.3,11.6-4.6l-2.3-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.88,42.1s-5.2,1-5.7,10.8c-.4,9.8,0,8.9,0,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M10.88,56.5h0c.6-1.7,.7-3.5,.4-5.2l-.4-2.4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbel);
export default __webpack_public_path__ + "static/media/Barbel.47865f62a79c622d4b9e4256dd8df249.svg";
export { ForwardRef as ReactComponent };